import { BPagination } from './pagination';
import { pluginFactory } from '../../utils/plugins';
var PaginationPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BPagination: BPagination
  }
});
export { PaginationPlugin, BPagination };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/pagination/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/pagination/index.js
// module chunks = 1